/**
 * Available densities.
 */

/**
 * Density enum.
 */
var GridDensityTypes;

(function (GridDensityTypes) {
  GridDensityTypes["Compact"] = "compact";
  GridDensityTypes["Standard"] = "standard";
  GridDensityTypes["Comfortable"] = "comfortable";
})(GridDensityTypes || (GridDensityTypes = {}));

export { GridDensityTypes };


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/models/gridDensity.js
// module id = 626
// module chunks = 25